import { render, staticRenderFns } from "./SkuRanking.vue?vue&type=template&id=39f12a86&scoped=true"
import script from "./SkuRanking.vue?vue&type=script&lang=js"
export * from "./SkuRanking.vue?vue&type=script&lang=js"
import style0 from "./SkuRanking.vue?vue&type=style&index=0&id=39f12a86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f12a86",
  null
  
)

export default component.exports